(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const R = window.themeRoutes || { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const desktop = () => matchMedia('(min-width:900px)').matches;
  gsap.registerPlugin(ScrollTrigger);

  /* ---------- smooth scroll ---------- */
  let lenis = null;
  if (!reduce && document.body.dataset.smooth !== 'false' && window.Lenis) {
    lenis = new Lenis({ lerp: 0.1 });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }

  /* ---------- header + progress ---------- */
  const hdr = $('[data-hdr]');
  ScrollTrigger.create({
    start: 0, end: 'max',
    onUpdate: self => {
      const y = self.scroll();
      hdr?.classList.toggle('is-scrolled', y > 20);
      hdr?.classList.toggle('is-hidden', self.direction === 1 && y > 320 && !$('.drawer.is-open'));
    }
  });
  if (!reduce) gsap.to('[data-progress]', { scaleX: 1, ease: 'none', scrollTrigger: { start: 0, end: 'max', scrub: 0.3 } });

  /* ---------- cart ---------- */
  const cart = {
    drawer: () => $('[data-drawer]'),
    async refresh() {
      const [sec, data] = await Promise.all([
        fetch(R.root + '?sections=cart-drawer').then(r => r.json()),
        fetch(R.cart + '.js').then(r => r.json())
      ]);
      const doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
      const nb = $('[data-drawer-body]', doc), cb = $('[data-drawer-body]');
      if (nb && cb) cb.innerHTML = nb.innerHTML;
      $$('[data-cart-count]').forEach(n => {
        n.textContent = data.item_count;
        if (!reduce) gsap.fromTo(n, { scale: 1.5 }, { scale: 1, duration: 0.5, ease: 'back.out(3)' });
      });
      return data;
    },
    async add(fd) {
      const r = await fetch(R.add + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
      await this.refresh();
      this.open();
    },
    async change(key, qty) {
      await fetch(R.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      await this.refresh();
      const d = this.drawer();
      if (!reduce && d) gsap.from($$('.line', d), { opacity: 0, y: 12, stagger: 0.04, duration: 0.35 });
    },
    open() {
      const d = this.drawer();
      if (!d || d.classList.contains('is-open')) return;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      lenis?.stop(); document.body.style.overflow = 'hidden';
      const t = reduce ? 0 : 1;
      gsap.to($('.drawer__veil', d), { opacity: 1, duration: 0.4 * t });
      gsap.to($('.drawer__panel', d), { xPercent: 0, duration: 0.6 * t, ease: 'power4.out' });
      if (!reduce) gsap.fromTo($$('.ship,.line,.drawer__foot,.drawer__empty', d), { opacity: 0, y: 20 }, { opacity: 1, y: 0, stagger: 0.07, duration: 0.5, delay: 0.25, ease: 'power3.out' });
      $('.drawer__x', d)?.focus();
    },
    close() {
      const d = this.drawer();
      if (!d || !d.classList.contains('is-open')) return;
      const t = reduce ? 0 : 1;
      gsap.to($('.drawer__veil', d), { opacity: 0, duration: 0.4 * t });
      gsap.to($('.drawer__panel', d), {
        xPercent: 100, duration: 0.45 * t, ease: 'power3.in',
        onComplete: () => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lenis?.start(); document.body.style.overflow = ''; }
      });
    }
  };
  window.themeCart = cart;
  { const d = cart.drawer(); if (d) gsap.set($('.drawer__panel', d), { xPercent: 100 }); }

  document.addEventListener('click', e => {
    const open = e.target.closest('[data-cart-open]');
    if (open && !e.metaKey && !e.ctrlKey && cart.drawer() && !document.body.classList.contains('template-cart')) { e.preventDefault(); cart.open(); return; }
    if (e.target.closest('[data-drawer-close]')) { cart.close(); return; }
    const q = e.target.closest('[data-q]');
    if (q) { cart.change(q.dataset.key, +q.dataset.q); return; }
    const qb = e.target.closest('[data-qty-btn]');
    if (qb) {
      const input = $('input[type=number]', qb.closest('.qty'));
      if (!input) return;
      input.value = Math.max(+input.min || 0, (+input.value || 0) + +qb.dataset.qtyBtn);
      const f = qb.closest('[data-cart-form]');
      if (f) { clearTimeout(f._t); f._t = setTimeout(() => f.requestSubmit(), 600); }
      return;
    }
    const rec = e.target.closest('[data-recover]');
    if (rec) { e.preventDefault(); const b = $('#recover'); b.hidden = !b.hidden; if (!b.hidden && !reduce) gsap.from(b, { opacity: 0, y: 14, duration: 0.5 }); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') cart.close(); });


  /* ---------- page curtain / intro ---------- */
  const cfg = window.themeCfg || {};
  const htmlEl = document.documentElement;
  const curtain = $('[data-curtain]');
  let cLetters = [];
  if (curtain) {
    const w = $('.curtain__w', curtain), txt = w.textContent.trim();
    w.textContent = '';
    cLetters = [...txt].map(ch => { const s = document.createElement('span'); s.textContent = ch === ' ' ? '\u00a0' : ch; w.append(s); return s; });
    gsap.set(curtain, { yPercent: htmlEl.classList.contains('pt-in') ? 0 : 100 });
  }
  window.__introDelay = 0;
  if (curtain && htmlEl.classList.contains('pt-in')) {
    let first = false;
    try { first = !sessionStorage.getItem('seen'); sessionStorage.setItem('seen', '1'); sessionStorage.removeItem('pt'); } catch (_) {}
    const intro = first && cfg.intro && cfg.home;
    window.__introDelay = intro ? 1.45 : 0.4;
    curtain.classList.add('is-on');
    const tl = gsap.timeline({ onComplete: () => { htmlEl.classList.remove('pt-in'); curtain.classList.remove('is-on'); gsap.set(curtain, { yPercent: 100 }); } });
    if (intro) tl.fromTo(cLetters, { yPercent: 120 }, { yPercent: 0, duration: 0.8, ease: 'power4.out', stagger: 0.06 }).to({}, { duration: 0.25 });
    else tl.to({}, { duration: 0.05 });
    tl.to(curtain, { yPercent: -100, duration: 0.9, ease: 'power4.inOut' });
  } else if (!cfg.design) { try { sessionStorage.setItem('seen', '1'); } catch (_) {} }

  function leave(href) {
    curtain.classList.add('is-on');
    try { sessionStorage.setItem('pt', '1'); } catch (_) {}
    gsap.set(cLetters, { yPercent: 0 });
    gsap.fromTo(curtain, { yPercent: 100 }, { yPercent: 0, duration: 0.6, ease: 'power3.inOut', onComplete: () => { location.href = href; } });
    setTimeout(() => { location.href = href; }, 1600);
  }
  if (cfg.trans && !cfg.design && !reduce && curtain) {
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-cart-open') || a.getAttribute('href').startsWith('#')) return;
      let u; try { u = new URL(a.href, location.href); } catch (_) { return; }
      if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search)) return;
      if (/\/(checkout|account|admin)/.test(u.pathname)) return;
      e.preventDefault(); leave(u.href);
    });
    addEventListener('pageshow', e => { if (e.persisted) { htmlEl.classList.remove('pt-in'); curtain.classList.remove('is-on'); gsap.set(curtain, { yPercent: 100 }); } });
  }

  /* ---------- cursor, magnet, tilt ---------- */
  const fine = matchMedia('(pointer:fine)').matches;
  if (cfg.cursor && fine && !reduce) {
    const c = $('[data-cursor]'), lab = $('span', c);
    const qx = gsap.quickTo(c, 'x', { duration: 0.35, ease: 'power3' }), qy = gsap.quickTo(c, 'y', { duration: 0.35, ease: 'power3' });
    const labels = [['.pdp__main', 'Zoom'], ['.card__img', 'View'], ['.jc__stage', 'Drag'], ['.hs__track', 'Drag'], ['[data-cursor-label]', null]];
    document.addEventListener('pointermove', e => {
      c.classList.add('is-on'); qx(e.clientX); qy(e.clientY);
      let l = null;
      for (const [sel, text] of labels) { const m = e.target.closest(sel); if (m) { l = text ?? m.dataset.cursorLabel; break; } }
      const link = e.target.closest('a,button,input,label,summary,select,textarea');
      if (l && !e.target.closest('.card__qa,.pdp__arrow,.jc__arrows,.qa-pop')) { lab.textContent = l; c.classList.add('is-label'); c.classList.remove('is-link'); }
      else { c.classList.remove('is-label'); c.classList.toggle('is-link', !!link); }
    });
    document.addEventListener('pointerleave', () => c.classList.remove('is-on'));
  }
  if (fine && !reduce) {
    const mag = '.btn,.jc__btn,.hdr__act a,.pdp__arrow,.jc__arrows button,.card__qa';
    let m = null, tiltEl = null;
    document.addEventListener('pointermove', e => {
      const t = e.target.closest(mag);
      if (m && m !== t) { gsap.to(m, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1,.45)' }); m = null; }
      if (t) { m = t; const r = t.getBoundingClientRect(); gsap.to(t, { x: (e.clientX - r.left - r.width / 2) * 0.28, y: (e.clientY - r.top - r.height / 2) * 0.28, duration: 0.3, ease: 'power3.out' }); }
      const ti = e.target.closest('.card__img');
      if (tiltEl && tiltEl !== ti) { gsap.to(tiltEl, { rotationX: 0, rotationY: 0, duration: 0.6, ease: 'power3.out' }); tiltEl = null; }
      if (ti) { tiltEl = ti; const r = ti.getBoundingClientRect(); gsap.to(ti, { rotationY: ((e.clientX - r.left) / r.width - 0.5) * 12, rotationX: -((e.clientY - r.top) / r.height - 0.5) * 12, transformPerspective: 900, duration: 0.4, ease: 'power2.out' }); }
    });
  }

  /* ---------- back to top ---------- */
  const totop = $('[data-totop]');
  if (totop) {
    const ring = $('[data-totop-ring]', totop);
    ScrollTrigger.create({ start: 0, end: 'max', onUpdate: s => { totop.classList.toggle('is-on', s.scroll() > 700); ring.style.strokeDashoffset = 126 * (1 - s.progress); } });
    totop.addEventListener('click', () => lenis ? lenis.scrollTo(0, { duration: 1.4 }) : scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }));
  }

  /* ---------- modals ---------- */
  const modal = {
    open(id) {
      const m = $(`[data-modal="${id}"]`); if (!m) return;
      m.hidden = false; lenis?.stop();
      gsap.fromTo($('.modal__veil', m), { opacity: 0 }, { opacity: 1, duration: reduce ? 0 : 0.3 });
      gsap.fromTo($('.modal__box', m), { y: 40, opacity: 0, scale: 0.96 }, { y: 0, opacity: 1, scale: 1, duration: reduce ? 0 : 0.5, ease: 'power3.out' });
    },
    close() { $$('.modal:not([hidden])').forEach(m => { m.hidden = true; }); lenis?.start(); }
  };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-modal-open]');
    if (o) { modal.open(o.dataset.modalOpen); return; }
    if (e.target.closest('[data-modal-close]')) modal.close();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { modal.close(); closeQA(); } });

  /* ---------- quick add ---------- */
  const pj = new Map();
  const getProduct = async h => { if (pj.has(h)) return pj.get(h); const r = await fetch(R.root + 'products/' + h + '.js'); if (!r.ok) throw new Error('not found'); const p = await r.json(); pj.set(h, p); return p; };
  function closeQA(except) {
    $$('.card__media.qa-open').forEach(m => { if (m === except) return; m.classList.remove('qa-open'); const p = $('[data-qa-pop]', m); if (p) p.hidden = true; });
  }
  const addVariant = async id => { const fd = new FormData(); fd.append('id', id); fd.append('quantity', 1); await cart.add(fd); };
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-qa]');
    if (!b) { if (!e.target.closest('[data-qa-pop]')) closeQA(); return; }
    const media = b.closest('.card__media'), pop = $('[data-qa-pop]', media);
    if (media.classList.contains('qa-open')) { closeQA(); return; }
    closeQA(media);
    try {
      const p = await getProduct(b.dataset.qa);
      const vs = p.variants;
      if (vs.length === 1) { b.classList.add('is-busy'); await addVariant(vs[0].id); return; }
      pop.innerHTML = `<p><span>Select ${(p.options[p.options.length - 1].name || p.options[p.options.length - 1]).toString().toLowerCase()}</span><button type="button" class="qa-pop__x" aria-label="Close">&times;</button></p><div class="qa-pop__opts">` +
        vs.map(v => `<button type="button" data-vid="${v.id}" ${v.available ? '' : 'disabled'}>${v.title}</button>`).join('') + '</div>';
      pop.hidden = false; media.classList.add('qa-open');
      if (!reduce) gsap.fromTo([pop, ...$$('.qa-pop__opts button', pop)], { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.4, stagger: 0.04, ease: 'power3.out' });
    } catch (_) { location.href = b.closest('.card').querySelector('a').href; }
  });
  document.addEventListener('click', async e => {
    const x = e.target.closest('.qa-pop__x'); if (x) { closeQA(); return; }
    const v = e.target.closest('.qa-pop [data-vid]'); if (!v) return;
    v.textContent = 'Adding…'; v.disabled = true;
    try { await addVariant(v.dataset.vid); closeQA(); } catch (_) { v.textContent = 'Error'; }
  });

  /* ---------- helpers ---------- */
  function split(el, plain) {
    el.dataset.orig ??= el.innerHTML;
    el.innerHTML = el.dataset.orig;
    const words = [];
    const walk = node => [...node.childNodes].forEach(n => {
      if (n.nodeType === 3) {
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(tok => {
          if (!tok) return;
          if (/^\s+$/.test(tok)) { frag.append(' '); return; }
          const w = document.createElement('span');
          if (plain) { w.className = 'sw'; w.textContent = tok; words.push(w); }
          else { w.className = 'w'; const i = document.createElement('span'); i.className = 'wi'; i.textContent = tok; w.append(i); words.push(i); }
          frag.append(w);
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
    });
    walk(el);
    el.style.visibility = 'visible';
    return words;
  }

  function avgColor(img) {
    try {
      const c = document.createElement('canvas'); c.width = c.height = 32;
      const x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, 32, 32);
      const d = x.getImageData(0, 0, 32, 32).data;
      let r = 0, g = 0, b = 0, n = 0;
      for (let i = 0; i < d.length; i += 4) { if (d[i + 3] < 200) continue; r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      if (!n) return null;
      r /= n; g /= n; b /= n;
      const mx = Math.max(r, g, b) / 255, mn = Math.min(r, g, b) / 255, l = (mx + mn) / 2;
      let h = 0, s = 0;
      if (mx !== mn) {
        const dd = mx - mn; s = l > 0.5 ? dd / (2 - mx - mn) : dd / (mx + mn);
        const R_ = r / 255, G_ = g / 255, B_ = b / 255;
        h = mx === R_ ? (G_ - B_) / dd + (G_ < B_ ? 6 : 0) : mx === G_ ? (B_ - R_) / dd + 2 : (R_ - G_) / dd + 4; h *= 60;
      }
      return `hsl(${Math.round(h)} ${Math.round(Math.max(0.25, Math.min(0.6, s)) * 100)}% ${Math.round(Math.max(0.3, Math.min(0.42, l)) * 100)}%)`;
    } catch (_) { return null; }
  }

  /* ---------- hero carousel ---------- */
  function initCarousel(el, cleanups) {
    const figs = $$('[data-fig]', el), panels = $$('[data-panel]', el), n = figs.length;
    if (!n) return;
    const stage = $('[data-jcstage]', el), look = $('[data-look]', el), imgs = figs.map(f => $('img', f));
    let cur = 0, busy = false, timer;
    const secs = +el.dataset.autoplay || 0;
    const rel = i => ((i - cur) % n + n) % n;
    const state = i => {
      const d = rel(i), w = stage.clientWidth, h = stage.clientHeight;
      if (d === 0) return { x: 0, y: 0, scale: 1, opacity: 1, filter: 'blur(0px)', zIndex: 3, pointerEvents: 'none' };
      if (d === 1) return { x: w * 0.36, y: h * 0.27, scale: 0.3, opacity: 1, filter: 'blur(0px)', zIndex: 2, pointerEvents: 'auto' };
      if (d === n - 1) return { x: -w * 0.2, y: -h * 0.2, scale: 0.6, opacity: 0, filter: 'blur(10px)', zIndex: 1, pointerEvents: 'none' };
      return { x: w * 0.4, y: h * 0.32, scale: 0.15, opacity: 0, filter: 'blur(0px)', zIndex: 1, pointerEvents: 'none' };
    };
    const layout = () => figs.forEach((f, i) => gsap.set(f, state(i)));
    layout();
    panels.forEach((p, i) => gsap.set(p, { autoAlpha: i === 0 ? 1 : 0 }));
    look.href = figs[0].dataset.url;
    gsap.set(el, { '--accent': figs[0].dataset.accent });

    function go(to) {
      if (busy || n < 2) return;
      const next = ((to % n) + n) % n;
      if (next === cur) return;
      busy = true;
      const prev = cur; cur = next;
      look.href = figs[cur].dataset.url;
      const d = reduce ? 0 : 1;
      const tl = gsap.timeline({ defaults: { duration: d, ease: 'power3.inOut' }, onComplete: () => { busy = false; } });
      figs.forEach((f, i) => {
        const s = state(i);
        gsap.set(f, { zIndex: s.zIndex, pointerEvents: s.pointerEvents });
        tl.to(f, { x: s.x, y: s.y, scale: s.scale, opacity: s.opacity, filter: s.filter }, 0);
      });
      tl.to(el, { '--accent': figs[cur].dataset.accent, duration: d }, 0)
        .to(panels[prev], { autoAlpha: 0, y: -12, duration: d * 0.35, ease: 'power2.in' }, 0)
        .fromTo(panels[cur], { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: d * 0.5, ease: 'power3.out' }, d * 0.45);
      restart();
    }
    function restart() {
      clearInterval(timer);
      if (secs && !reduce && n > 1) timer = setInterval(() => { if (!document.hidden) go(cur + 1); }, secs * 1000);
    }
    $('[data-next]', el).addEventListener('click', () => go(cur + 1));
    $('[data-prev]', el).addEventListener('click', () => go(cur - 1));
    figs.forEach((f, i) => f.addEventListener('click', () => { if (rel(i) === 1) go(cur + 1); }));
    let sx = null;
    stage.addEventListener('pointerdown', e => { sx = e.clientX; });
    const up = e => { if (sx === null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 60) go(cur + (dx < 0 ? 1 : -1)); };
    addEventListener('pointerup', up);
    el.addEventListener('pointerenter', () => clearInterval(timer));
    el.addEventListener('pointerleave', restart);
    const ro = new ResizeObserver(() => { if (!busy) layout(); }); ro.observe(stage);
    restart();
    cleanups.push(() => { clearInterval(timer); ro.disconnect(); removeEventListener('pointerup', up); });

    if (reduce) return;
    gsap.fromTo(figs[0], { scale: 0.7, y: 60, opacity: 0 }, { ...state(0), duration: 1.2, ease: 'power3.out', delay: window.__introDelay || 0 });
    gsap.from($$('.jc__left > *, .jc__right, .jc__tag', el), { y: 22, opacity: 0, stagger: 0.08, duration: 0.7, ease: 'power3.out', delay: 0.3 + (window.__introDelay || 0) });
    gsap.to(imgs, { y: -10, duration: 2.4, yoyo: true, repeat: -1, ease: 'sine.inOut', stagger: 0.5 });
    gsap.set(imgs, { transformPerspective: 900 });
    const tY = imgs.map(im => gsap.quickTo(im, 'rotationY', { duration: 0.8, ease: 'power3' }));
    const tX = imgs.map(im => gsap.quickTo(im, 'rotationX', { duration: 0.8, ease: 'power3' }));
    el.addEventListener('pointermove', e => {
      const r = el.getBoundingClientRect();
      const nx = (e.clientX - r.left) / r.width - 0.5, ny = (e.clientY - r.top) / r.height - 0.5;
      tY.forEach(q => q(nx * 14)); tX.forEach(q => q(-ny * 8));
    });
  }

  /* ---------- product page ---------- */
  function initPDP(root) {
    const form = $('[data-pdp-form]', root);
    const { variants } = JSON.parse($('[data-pdp-json]', root).textContent);
    const idInput = $('[data-variant-id]', form), atc = $('[data-atc]', form);
    const fields = $$('[data-opt]', form);
    const figs = $$('[data-media]', root), thumbs = $$('[data-thumb]', root);
    const main = $('[data-main]', root), priceEl = $('[data-price]', root), stockEl = $('[data-stock]', root);
    const bar = $('[data-pdp-bar]', root), barAtc = $('[data-bar-atc]', root), barPrice = $('[data-bar-price]', root);
    const err = $('[data-pdp-error]', root);
    let cur = Math.max(0, figs.findIndex(f => f.classList.contains('is-on')));
    figs.forEach((f, i) => gsap.set(f, { autoAlpha: i === cur ? 1 : 0, zIndex: i === cur ? 2 : 1 }));
    const fixed = root.dataset.accent;

    const setAccent = () => {
      if (fixed) return;
      const img = $('img', figs[cur]); if (!img) return;
      const src = img.currentSrc || img.src; if (!src) return;
      const probe = new Image(); probe.crossOrigin = 'anonymous';
      probe.onload = () => { const c = avgColor(probe); if (c) gsap.to(root, { '--accent': c, duration: reduce ? 0 : 0.8 }); };
      probe.src = src;
    };
    setAccent();

    function show(i) {
      if (i === cur || !figs[i]) return;
      const from = figs[cur], to = figs[i], d = i > cur ? 1 : -1, t = reduce ? 0 : 1;
      gsap.set(to, { zIndex: 2 });
      gsap.fromTo(to, { x: 70 * d, autoAlpha: 0, scale: 0.96 }, { x: 0, autoAlpha: 1, scale: 1, duration: 0.7 * t, ease: 'power3.out' });
      gsap.to(from, { x: -70 * d, autoAlpha: 0, duration: 0.5 * t, ease: 'power2.in', onComplete: () => gsap.set(from, { zIndex: 1 }) });
      thumbs.forEach((b, k) => b.classList.toggle('is-on', k === i));
      cur = i; setAccent();
    }
    thumbs.forEach((b, i) => b.addEventListener('click', () => show(i)));
    $('[data-gal-next]', root)?.addEventListener('click', () => show((cur + 1) % figs.length));
    $('[data-gal-prev]', root)?.addEventListener('click', () => show((cur - 1 + figs.length) % figs.length));
    let sx = null;
    main.addEventListener('pointerdown', e => { sx = e.clientX; });
    main.addEventListener('pointerup', e => { if (sx === null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 50) show(dx < 0 ? Math.min(cur + 1, figs.length - 1) : Math.max(cur - 1, 0)); });
    if (matchMedia('(pointer:fine)').matches && !reduce) {
      main.addEventListener('pointerenter', () => main.classList.add('is-zoom'));
      main.addEventListener('pointerleave', () => main.classList.remove('is-zoom'));
      main.addEventListener('pointermove', e => { const r = main.getBoundingClientRect(); main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
    }

    const sel = () => fields.map(f => $('input:checked', f)?.value);
    const find = () => { const s = sel(); return variants.find(v => v.options.every((o, i) => !fields.length || o === s[i])); };
    function avail() {
      const s = sel();
      fields.forEach((f, i) => $$('input', f).forEach(inp => {
        const t = [...s]; t[i] = inp.value;
        inp.closest('label').classList.toggle('is-oos', !variants.some(v => v.available && v.options.every((o, k) => t[k] === o)));
      }));
    }
    function update() {
      fields.forEach(f => { const l = $('[data-opt-label]', f); if (l) l.textContent = $('input:checked', f)?.value || ''; });
      avail();
      const v = find();
      if (!v) { atc.disabled = true; atc.textContent = 'Unavailable'; if (barAtc) { barAtc.disabled = true; barAtc.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      priceEl.innerHTML = `<strong>${v.price}</strong>` + (v.cmp ? `<s>${v.cmp}</s><em>Save ${v.save}%</em>` : '');
      if (barPrice) barPrice.textContent = v.price;
      stockEl.textContent = v.stock || '';
      const label = v.available ? 'Add to cart' : 'Sold out';
      atc.disabled = !v.available; atc.textContent = label;
      if (barAtc) { barAtc.disabled = !v.available; barAtc.textContent = label; }
      if (v.media) { const i = figs.findIndex(f => +f.dataset.media === v.media); if (i > -1) show(i); thumbs.forEach((b, k) => b.classList.toggle('is-on', k === cur)); }
      history.replaceState(null, '', '?variant=' + v.id);
      if (!reduce) gsap.fromTo(priceEl, { y: 8, opacity: 0.4 }, { y: 0, opacity: 1, duration: 0.4 });
    }
    fields.forEach(f => f.addEventListener('change', update));
    avail();

    form.addEventListener('submit', async e => {
      e.preventDefault();
      err.hidden = true;
      const label = atc.textContent;
      atc.disabled = true; atc.textContent = 'Adding…';
      try { await cart.add(new FormData(form)); atc.textContent = 'Added'; }
      catch (ex) { err.textContent = ex.message; err.hidden = false; atc.textContent = label; }
      setTimeout(update, 1300);
    });
    barAtc?.addEventListener('click', () => form.requestSubmit());

    if (bar) {
      const io = new IntersectionObserver(([en]) => {
        const show_ = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', show_); bar.setAttribute('aria-hidden', String(!show_));
      });
      io.observe(atc);
    }

    $$('[data-acc]', root).forEach(d => {
      const c = $('[data-acc-body]', d);
      $('summary', d).addEventListener('click', e => {
        e.preventDefault();
        if (d.open) gsap.to(c, { height: 0, duration: reduce ? 0 : 0.4, ease: 'power2.inOut', onComplete: () => { d.open = false; gsap.set(c, { clearProps: 'height' }); } });
        else { d.open = true; gsap.fromTo(c, { height: 0 }, { height: 'auto', duration: reduce ? 0 : 0.45, ease: 'power2.out' }); }
      });
    });
    if (reduce) return;
    gsap.fromTo($$('[data-in]', root), { opacity: 0, y: 26 }, { opacity: 1, y: 0, stagger: 0.07, duration: 0.7, ease: 'power3.out', delay: 0.25 });
  }

  /* ---------- collection filters ---------- */
  function initFilters(root) {
    const f = $('[data-filters]', root); if (!f) return;
    const panel = $('[data-fpanel]', f), tg = $('[data-filter-toggle]', f);
    tg?.addEventListener('click', () => {
      const open = tg.getAttribute('aria-expanded') === 'true';
      tg.setAttribute('aria-expanded', String(!open));
      gsap.to(panel, { height: open ? 0 : 'auto', duration: reduce ? 0 : 0.5, ease: 'power3.inOut' });
    });
    $('[data-sort]', f)?.addEventListener('change', () => f.requestSubmit());
    $$('input[type=checkbox]', f).forEach(i => i.addEventListener('change', () => f.requestSubmit()));
  }

  /* ---------- scroll animations ---------- */
  function initMarquee(root) {
    $$('[data-mq]', root).forEach(m => {
      const track = $('[data-mq-track]', m);
      const tw = gsap.to(track, { xPercent: -50, duration: +m.dataset.speed || 30, ease: 'none', repeat: -1 });
      ScrollTrigger.create({
        trigger: m, start: 'top bottom', end: 'bottom top',
        onUpdate: self => {
          const dir = self.direction;
          gsap.to(tw, { timeScale: dir * (1 + Math.min(Math.abs(self.getVelocity()) / 240, 6)), duration: 0.2, overwrite: true, onComplete: () => gsap.to(tw, { timeScale: dir, duration: 0.9 }) });
        }
      });
    });
  }

  function initStory(root) {
    $$('[data-story]', root).forEach(st => {
      if (!desktop()) return;
      const img = $('[data-story-img]', st), pin = $('.story__pin', st), p = $('.story__p', st), h = $('h2', st);
      const words = split(p, true), hw = split(h, false);
      p.dataset.done = h.dataset.done = '1';
      gsap.set(words, { opacity: 0.16 });
      const nums = $$('[data-count]', st); nums.forEach(n => { n.dataset.done = '1'; n.textContent = '0'; });
      let counted = false;
      const tl = gsap.timeline({ defaults: { ease: 'none' }, scrollTrigger: { trigger: pin, start: 'center center', end: '+=120%', pin: true, scrub: 0.6 } });
      tl.fromTo(img, { scale: 0.78, borderRadius: 80 }, { scale: 1, borderRadius: 32 }, 0)
        .fromTo(hw, { yPercent: 115 }, { yPercent: 0, stagger: 0.08 }, 0)
        .to(words, { opacity: 1, stagger: 0.12 }, 0.1)
        .fromTo($$('.story__stats li', st), { opacity: 0, y: 30 }, { opacity: 1, y: 0, stagger: 0.2 }, 0.75)
        .call(() => {
          if (counted) return; counted = true;
          nums.forEach(n => { const o = { v: 0 }, end = +n.dataset.count; gsap.to(o, { v: end, duration: 1.6, ease: 'power2.out', onUpdate: () => (n.textContent = Math.round(o.v)) }); });
        }, null, 0.8);
    });
  }

  function initHS(root) {
    $$('[data-hs]', root).forEach(hs => {
      if (!desktop()) return;
      const track = $('[data-hs-track]', hs), pin = $('.hs__pin', hs), bar = $('[data-hs-bar]', hs);
      const dist = () => Math.max(0, track.scrollWidth - innerWidth + 56);
      gsap.to(track, {
        x: () => -dist(), ease: 'none',
        scrollTrigger: { trigger: pin, start: 'top top', end: () => '+=' + dist(), pin: true, scrub: 0.6, invalidateOnRefresh: true, onUpdate: s => gsap.set(bar, { scaleX: s.progress }) }
      });
      $$('.card__img', track).forEach(c => gsap.fromTo(c, { rotate: -2 }, { rotate: 2, ease: 'none', scrollTrigger: { trigger: pin, start: 'top top', end: () => '+=' + dist(), scrub: true } }));
    });
  }

  function generic(root) {
    $$('[data-split]', root).forEach(el => {
      if (el.dataset.done) return;
      const scrub = el.dataset.split === 'scrub';
      const words = split(el, scrub);
      if (scrub) gsap.fromTo(words, { opacity: 0.16 }, { opacity: 1, stagger: 0.1, ease: 'none', scrollTrigger: { trigger: el, start: 'top 88%', end: 'bottom 55%', scrub: true } });
      else gsap.fromTo(words, { yPercent: 115, rotate: 4 }, { yPercent: 0, rotate: 0, duration: 1, ease: 'power4.out', stagger: 0.045, scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
    });
    $$('[data-reveal]', root).forEach(el => {
      const k = el.dataset.reveal;
      const from = k === 'fade' ? { opacity: 0 } : k === 'scale' ? { opacity: 0, scale: 0.88 } : k === 'left' ? { opacity: 0, x: -60 } : k === 'right' ? { opacity: 0, x: 60 } : { opacity: 0, y: 36 };
      gsap.fromTo(el, from, { opacity: 1, x: 0, y: 0, scale: 1, duration: 0.9, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
    });
    $$('[data-stagger]', root).forEach(c => {
      const kids = [...c.children];
      if (!kids.length) return;
      ScrollTrigger.batch(kids, { start: 'top 94%', once: true, onEnter: b => gsap.fromTo(b, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', stagger: 0.08, overwrite: true }) });
    });
    $$('[data-clip]', root).forEach(el => {
      gsap.fromTo(el, { clipPath: 'inset(10% 6% 10% 6% round 28px)' }, { clipPath: 'inset(0% 0% 0% 0% round 28px)', duration: 1.3, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
    });
    $$('[data-parallax]', root).forEach(w => {
      const img = $('img', w); if (!img) return;
      const p = +w.dataset.parallax || 0.1;
      gsap.fromTo(img, { yPercent: -p * 100, scale: 1 + p * 2.2 }, { yPercent: p * 100, ease: 'none', scrollTrigger: { trigger: w, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    $$('[data-count]', root).forEach(el => {
      if (el.dataset.done) return;
      const o = { v: 0 }, end = +el.dataset.count; el.textContent = '0';
      gsap.to(o, { v: end, duration: 1.6, ease: 'power2.out', onUpdate: () => (el.textContent = Math.round(o.v)), scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
    });
    $$('[data-ftr-word]', root).forEach(w => gsap.fromTo(w, { yPercent: 35, opacity: 0.4 }, { yPercent: 0, opacity: 1, ease: 'none', scrollTrigger: { trigger: w, start: 'top bottom', end: 'bottom bottom', scrub: true } }));
  }


  /* ---------- drop countdown ---------- */
  function initDrop(el, cleanups) {
    const raw = (el.dataset.date || '').trim();
    let end = raw ? new Date(raw.replace(' ', 'T')) : null;
    if (!end || isNaN(end)) end = new Date(Date.now() + (3 * 24 + 5) * 3600 * 1000);
    const units = { days: $('[data-u=days] span', el), hours: $('[data-u=hours] span', el), minutes: $('[data-u=minutes] span', el), seconds: $('[data-u=seconds] span', el) };
    const prev = {};
    const set = (k, v) => {
      const s = String(v).padStart(2, '0');
      if (prev[k] === s) return;
      if (prev[k] !== undefined && !reduce) gsap.fromTo(units[k], { yPercent: 80, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.45, ease: 'power3.out' });
      units[k].textContent = s; prev[k] = s;
    };
    const tick = () => {
      let d = Math.max(0, end - Date.now());
      if (d === 0) { $('[data-clock]', el).hidden = true; $('[data-live]', el).hidden = false; clearInterval(t); return; }
      const s = Math.floor(d / 1000);
      set('days', Math.floor(s / 86400)); set('hours', Math.floor(s % 86400 / 3600)); set('minutes', Math.floor(s % 3600 / 60)); set('seconds', s % 60);
    };
    const t = setInterval(tick, 1000); tick();
    cleanups.push(() => clearInterval(t));
  }

  /* ---------- shop the look ---------- */
  function initLook(st, cleanups) {
    const hots = $$('[data-hot]', st), inner = $('[data-stl-inner]', st);
    const closeAll = () => hots.forEach(h => { h.classList.remove('is-open'); $('.hot__dot', h).setAttribute('aria-expanded', 'false'); });
    const open = h => {
      closeAll(); h.classList.add('is-open'); $('.hot__dot', h).setAttribute('aria-expanded', 'true');
      if (!reduce) gsap.fromTo($('.hot__card', h), { opacity: 0, y: 10, scale: 0.9 }, { opacity: 1, y: 0, scale: 1, duration: 0.45, ease: 'back.out(2)' });
    };
    hots.forEach(h => {
      $('.hot__dot', h).addEventListener('click', e => { e.stopPropagation(); h.classList.contains('is-open') ? closeAll() : open(h); });
      if (fine) h.addEventListener('pointerenter', () => { if (!h.classList.contains('is-open')) open(h); });
    });
    const out = e => { if (!e.target.closest('.hot')) closeAll(); };
    document.addEventListener('click', out); cleanups.push(() => document.removeEventListener('click', out));
    if (reduce) return;
    gsap.from(hots, { scale: 0, stagger: 0.14, duration: 0.7, ease: 'back.out(3)', scrollTrigger: { trigger: st, start: 'top 65%', once: true } });
    gsap.fromTo(inner, { yPercent: 6, rotate: -2 }, { yPercent: -6, rotate: 2, ease: 'none', scrollTrigger: { trigger: st, start: 'top bottom', end: 'bottom top', scrub: true } });
    if (fine) {
      const qx = gsap.quickTo(inner, 'x', { duration: 0.9, ease: 'power3' });
      st.addEventListener('pointermove', e => { const r = st.getBoundingClientRect(); qx(((e.clientX - r.left) / r.width - 0.5) * -24); });
    }
  }

  /* ---------- recently viewed ---------- */
  function recordView(root) {
    const h = root.dataset.handle; if (!h) return;
    try { const l = JSON.parse(localStorage.getItem('rv') || '[]').filter(x => x !== h); l.unshift(h); localStorage.setItem('rv', JSON.stringify(l.slice(0, 12))); } catch (_) {}
  }
  function initRV(root) {
    $$('[data-rv]', root).forEach(async sec => {
      let l = []; try { l = JSON.parse(localStorage.getItem('rv') || '[]'); } catch (_) {}
      l = l.filter(h => h !== sec.dataset.exclude).slice(0, 4);
      if (!l.length) return;
      const items = (await Promise.all(l.map(h => getProduct(h).catch(() => null)))).filter(Boolean);
      if (!items.length) return;
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
      const money = c => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100); } catch (_) { return (c / 100).toFixed(2); } };
      const grid = $('[data-rv-grid]', sec);
      grid.innerHTML = items.map(p => `<article class="card"><div class="card__media"><a class="card__img" href="${p.url}" aria-label="${p.title.replace(/"/g, '&quot;')}"><img class="card__a" src="${p.featured_image}" alt="" loading="lazy" width="700" height="700"></a></div><div class="card__meta"><h3><a href="${p.url}">${p.title}</a></h3><span class="card__price">${money(p.price)}</span></div></article>`).join('');
      sec.hidden = false;
      if (!reduce) gsap.fromTo($$('.card', grid), { opacity: 0, y: 50 }, { opacity: 1, y: 0, stagger: 0.08, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: grid, start: 'top 92%', once: true } });
      ScrollTrigger.refresh();
    });
  }

  /* ---------- section lifecycle ---------- */
  const live = new WeakMap();
  function initSection(root) {
    live.get(root)?.revert();
    const cleanups = [];
    const ctx = gsap.context(() => {
      $$('[data-split]', root).forEach(e => delete e.dataset.done);
      $$('[data-jc]', root).forEach(e => initCarousel(e, cleanups));
      $$('[data-pdp]', root).forEach(el => { initPDP(el); recordView(el); });
      $$('[data-drop]', root).forEach(el => initDrop(el, cleanups));
      $$('[data-stl]', root).forEach(el => initLook(el, cleanups));
      initRV(root);
      initFilters(root);
      if (!reduce) { initMarquee(root); initStory(root); initHS(root); generic(root); }
    }, root);
    live.set(root, { revert: () => { cleanups.forEach(f => f()); ctx.revert(); } });
  }
  const initAll = () => { $$('.shopify-section').forEach(initSection); ScrollTrigger.refresh(); window.__animOk = true; };

  initAll();
  addEventListener('load', () => ScrollTrigger.refresh());
  document.addEventListener('shopify:section:load', e => { initSection(e.target); ScrollTrigger.refresh(); });
  document.addEventListener('shopify:section:unload', e => live.get(e.target)?.revert());
})();
